// extracted by mini-css-extract-plugin
export default {"content":"page_content__3jrXd","verticalFiller":"page_verticalFiller__G8m25"};